/* What is left after #2009 moved the form's GEOMETRY into the shared
 * `FormLayoutSections` primitive that Portal mounts too.
 *
 * Everything that used to live here — `.section`, `.legend`, `.grid`, the four
 * `.columns*` recipes and `.fieldCell` with its `data-span-*` rules — is now in
 * `packages/ui/src/form/FormLayoutSections.module.css`, including the
 * `float: left` legend workaround, which is a property of `<legend>` rather
 * than of the host that met it first.
 *
 * They are DELETED rather than left in place. A stylesheet keeping rules no
 * element can match is how a "shared" component ends up with two sources of
 * truth: the next person edits the copy that is still here, sees nothing
 * change, and concludes the shared one is broken. The two `@media` breakpoints
 * went with them — the shared sheet asks `@container` instead, because a record
 * in a narrow split pane inside a wide window is the case a viewport query
 * cannot answer.
 *
 * `.mono` went too: nothing referenced it. */
.form { display: flex; flex-direction: column; }
